const JOB_KEY = "ml_jobs";
const DASHBOARD_API = process.env.REACT_APP_DASHBOARD_API_URL || "http://localhost:8200/dashboard";
export const ML_API = `${DASHBOARD_API}/livechat/ml`;
export function saveJob(job) {
  const jobs = getJobs();
  jobs[job.job_id] = job;
  localStorage.setItem(JOB_KEY, JSON.stringify(jobs));
}

export function getJobs() {
  return JSON.parse(localStorage.getItem(JOB_KEY) || "{}");
}

export function getJob(jobId) {
  return getJobs()[jobId];
}

export function updateJob(jobId, updates) {
  const jobs = getJobs();
  jobs[jobId] = { ...jobs[jobId], ...updates };
  localStorage.setItem(JOB_KEY, JSON.stringify(jobs));
}

export function removeJob(jobId) {
  const jobs = getJobs();
  delete jobs[jobId];
  localStorage.setItem(JOB_KEY, JSON.stringify(jobs));
}
